import api from '../index'

/**
 * @param {object} data 传参
 * @description 获取公钥
 * @returns {Promise} 请求结果
 */
export function reqPubKey(data: any) {
  return api.post('/user/public/pubKey', data)
}
/**
 * @param {object} data 传参
 * @description 帐号密码登录接口
 * @returns {Promise} 请求结果
 */
export function reqLogin(data: any) {
  return api.post('/user/public/login', data)
}
/**
 * @param {object} data 传参
 * @description 获取验证码
 * @returns {Promise} 请求结果
 */
export function reqCaptcha(data: any) {
  return api.post('/public/captcha', data)
}
/**
 * @param {object} data 传参
 * @description 获取验证码设置
 * @returns {Promise} 请求结果
 */
export function reqCaptchaSetting(data: any) {
  return api.post('/public/captchaSetting', data)
}
/**
 * @description 当前登录用户详情
 * @returns {Promise} 请求结果
 */
export function reqUserInfo() {
  return api.post('/common/user/detail', {})
}
/**
 * @description 注册
 * @returns {Promise} 请求结果
 */
export function reqUserRegister(data: any) {
  return api.post('/user/public/register', data)
}
/**
 * @description 重置密码
 * @returns {Promise} 请求结果
 */
export function reqUserResetPassword(data: any) {
  return api.post('/user/my/resetPassword', data)
}
